import { getPublicTemplate } from '@/api';
import type { Vacancy } from '@/api/generated/types.gen';
import type { AxiosError } from 'axios';

export type ApplyPageUnavailableReason = 'not-found' | 'unavailable';

export type LoadPublicTemplateResult = {
  vacancy?: Vacancy;
  unavailableReason?: ApplyPageUnavailableReason;
};

function getResponseStatus(result: unknown): number | undefined {
  const axiosResult = result as AxiosError;
  return axiosResult.response?.status ?? (result as { status?: number }).status;
}

export async function loadPublicTemplate(
  publicId: string,
): Promise<LoadPublicTemplateResult> {
  const result = await getPublicTemplate({
    path: { public_id: publicId },
  });

  const status = getResponseStatus(result);
  if (status === 402) {
    return { unavailableReason: 'unavailable' };
  }

  if (status && status >= 400) {
    return { unavailableReason: 'not-found' };
  }

  const vacancy = (result as { data?: Vacancy }).data;
  if (!vacancy?.public_id) {
    return { unavailableReason: 'not-found' };
  }

  return { vacancy };
}
